'use strict';
import * as $j_app$002edata$002e$002dForm$002dQuantity from "./app.data.-Form-Quantity.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_FormQuantity$() {
}
export { $c_Lapp_data_FormQuantity$ as $c_Lapp_data_FormQuantity$ };
$p = $c_Lapp_data_FormQuantity$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity$;
/** @constructor */
function $h_Lapp_data_FormQuantity$() {
}
export { $h_Lapp_data_FormQuantity$ as $h_Lapp_data_FormQuantity$ };
$h_Lapp_data_FormQuantity$.prototype = $p;
$p.Eb = (function(evidence$1, schema) {
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$1) => _$1.gy));
  var schemaType$1 = schema.ag.mp(g);
  var this$1 = schema.bb;
  if (this$1.c()) {
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$1.g();
    matchResult4: {
      var default$1;
      if ((arg1 !== null)) {
        var t = arg1.a0();
        var raw = arg1.a3();
        var this$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(new $j_app$002edata$002e$002dForm$002dQuantity.$c_Lapp_data_FormQuantity(t, evidence$1));
        var default$1 = (this$4.c() ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$() : new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), this$4.a7, raw)));
        break matchResult4;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(arg1);
    }
  }
  var validator$1 = schema.b8.rr(g);
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_Schema(schemaType$1, schema.bg, schema.bc, schema.be, default$1, schema.aj, schema.bf, schema.jL, schema.b7, validator$1, schema.b6);
});
$p.yn = (function(evidence$1, evidence$2) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => new $j_app$002edata$002e$002dForm$002dQuantity.$c_Lapp_data_FormQuantity(evidence$1.aP(), evidence$2))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
});
$p.uk = (function(evidence$1, dec, enc) {
  var this$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Invariant$ToInvariantOps$$anon$19(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Codec$$anon$4(dec, enc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Codec$()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Codec$().Nr);
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((quantity) => new $j_app$002edata$002e$002dForm$002dQuantity.$c_Lapp_data_FormQuantity(quantity, evidence$1)));
  var g = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$2) => _$2.gy));
  return this$6.Mn.eT(this$6.Mm, f, g);
});
var $d_Lapp_data_FormQuantity$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity$, "app.data.FormQuantity$", ({
  DD: 1
}));
export { $d_Lapp_data_FormQuantity$ as $d_Lapp_data_FormQuantity$ };
var $n_Lapp_data_FormQuantity$;
function $m_Lapp_data_FormQuantity$() {
  if ((!$n_Lapp_data_FormQuantity$)) {
    $n_Lapp_data_FormQuantity$ = new $c_Lapp_data_FormQuantity$();
  }
  return $n_Lapp_data_FormQuantity$;
}
export { $m_Lapp_data_FormQuantity$ as $m_Lapp_data_FormQuantity$ };
//# sourceMappingURL=app.data.-Form-Quantity$.js.map
